import dayjs from "dayjs";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";

dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);

/**
 * Gère le changement de valeur des inputs
 * @param {Event} e - Événement du champ de saisie.
 * @param {Function} setDataToSend - Setter pour mettre à jour les données.
 * @param {Function} setErrors - Setter pour mettre à jour les erreurs.
 */
export const onChange = (e, setDataToSend, setErrors) => {
    const { id, value, files } = e.target;

    setDataToSend((prev) => ({
        ...prev,
        [id]: files ? files[0] : value,
    }));

    setErrors((prev) => ({
        ...prev,
        [id]: "",
    }));
};

/**
 * Valide un formulaire et met à jour les erreurs si nécessaire.
 * @param {Object} dataToSend - Données du formulaire.
 * @param {Array} selected - Liste des champs requis.
 * @param {Function} setErrors - Setter pour mettre à jour les erreurs.
 * @returns {boolean} - Retourne `true` si le formulaire est valide, sinon `false`.
 */
export const validateForm = (dataToSend, selected, setErrors) => {
    let newErrors = {};

    selected.forEach((item) => {
        if (!dataToSend[item.fieldId]) {
            newErrors[item.fieldId] = `Ce champ ${item.fieldId} est requis`;
        }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
};

/**
 * Gère la soumission du formulaire.
 * @param {Object} dataToSend - Données à envoyer.
 * @param {Array} selected - Champs requis pour validation.
 * @param {Function} setErrors - Setter pour mettre à jour les erreurs.
 * @param {Function} send - Fonction pour envoyer les données.
 * @param {Function} setShowForm - Setter pour afficher/masquer le formulaire.
 */
export const handleSubmit = (dataToSend, selected, setErrors, send, setShowForm) => {
    if (validateForm(dataToSend, selected, setErrors)) {
        send(dataToSend);
        setShowForm((prev) => !prev);
    }
};

/**
 * Filtre les données en fonction de la période sélectionnée.
 * @param {Array} data - Liste des données.
 * @param {string} filter - Type de filtre: 'today', 'this_week', 'this_month', 'this_year'.
 * @returns {Array} - Données filtrées.
 */
export const filterDataByDate = (data, filter) => {
    if (!data) return [];

    console.log('data', data)
    const now = dayjs();

    return data?.data ? data?.data?.filter((item) => {
        const createdAt = dayjs(item.attributes.createdAt);

        switch (filter) {
            case "today":
                return createdAt.isSame(now, "day");
            case "this_week":
                return createdAt.isSameOrAfter(now.startOf("week")) && createdAt.isSameOrBefore(now.endOf("week"));
            case "this_month":
                return createdAt.isSame(now, "month");
            case "this_year":
                return createdAt.isSame(now, "year");
            default:
                return true;
        }
    }) : data?.filter((item) => {
        const createdAt = dayjs(item.attributes.createdAt);

        switch (filter) {
            case "today":
                return createdAt.isSame(now, "day");
            case "this_week":
                return createdAt.isSameOrAfter(now.startOf("week")) && createdAt.isSameOrBefore(now.endOf("week"));
            case "this_month":
                return createdAt.isSame(now, "month");
            case "this_year":
                return createdAt.isSame(now, "year");
            default:
                return true;
        }
    })
};


export const filterRedevDataByDate = (data, filter) => {
    if (!data) return [];

    console.log('data', data)
    const now = dayjs();

    return data?.data ? data?.data?.filter((item) => {
        const createdAt = dayjs(item.prochaineMensualite.date);

        switch (filter) {
            case "today":
                return createdAt.isSame(now, "day");
            case "this_week":
                return createdAt.isSameOrAfter(now.startOf("week")) && createdAt.isSameOrBefore(now.endOf("week"));
            case "this_month":
                return createdAt.isSame(now, "month");
            case "this_year":
                return createdAt.isSame(now, "year");
            default:
                return true;
        }
    }) : data?.filter((item) => {
        const createdAt = dayjs(item.attributes.createdAt);

        switch (filter) {
            case "today":
                return createdAt.isSame(now, "day");
            case "this_week":
                return createdAt.isSameOrAfter(now.startOf("week")) && createdAt.isSameOrBefore(now.endOf("week"));
            case "this_month":
                return createdAt.isSame(now, "month");
            case "this_year":
                return createdAt.isSame(now, "year");
            default:
                return true;
        }
    })
};